import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { TagColorTagFragmentDoc } from './TagColorTag.generated'
import * as Types from './purchasePlus_graphql'

export const GetProductModalProductTagsDocument = gql`
  query GetProductModalProductTags($productId: Int!, $tagFilters: ProductTagsQueryFiltersInput) {
    product(id: $productId) {
      id
      productTags(filters: $tagFilters) {
        unpaginated {
          id
          ...TagColorTag
        }
        totalCount
      }
    }
  }
  ${TagColorTagFragmentDoc}
` as unknown as DocumentNode<Types.GetProductModalProductTagsQuery, Types.GetProductModalProductTagsQueryVariables>
